module.exports = __webpack_public_path__ + "img/full02.3a5ab9c6.svg";